import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'studentrecordings';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const studentrecordingsActions = { ...slice.actions, ...extraActions };
export const studentrecordingsReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        studentRecordings: studentRecordings(),
        deleteStudentRecording: deleteStudentRecording(),
    };    

    function studentRecordings() {
        return createAsyncThunk(
            `${name}/studentrecordings`,
            async ({student_id}) => await fetchWrapper.get(`${baseUrl}/studentrecordings/allresults/`+student_id)
        );
    }

    function deleteStudentRecording() {
        return createAsyncThunk(
            `${name}/studentrecordings`,
            async ({record_id}) => await fetchWrapper.delete(`${baseUrl}/studentrecordings/delete/`+record_id)
        );
    }

}

function createExtraReducers() {
    return {
        ...studentRecordings(),
        ...deleteStudentRecording(),
    };

    function studentRecordings() {
        var { pending, fulfilled, rejected } = extraActions.studentRecordings;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const studentRecordings = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                state.studentRecordings = studentRecordings;
                
                // toast.success('Check your email to verify the account..', {
                //     position: "top-right",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                //     });
                // get return url from location state or default to home page
                // const { from } = { from: { pathname: '/verify-email' } };
                // history.navigate(from);
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

    function deleteStudentRecording() {
        var { pending, fulfilled, rejected } = extraActions.deleteStudentRecording;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const studentRecordings = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                state.studentRecordings = studentRecordings;
                
                // toast.success('Check your email to verify the account..', {
                //     position: "top-right",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                //     });
                // get return url from location state or default to home page
                // const { from } = { from: { pathname: '/verify-email' } };
                // history.navigate(from);
            },
            [rejected]: (state, action) => {
                console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }

}
